export default {"src":"/_next/static/media/nuviad_logo_final.e1af6adf.svg","height":153,"width":552,"blurWidth":0,"blurHeight":0};